import { CloseCircleOutlined, EnvironmentOutlined } from "@ant-design/icons"
import { Dropdown, Input, theme } from "antd"
import usePredictions from "modules/google/hooks/usePredictions"
import PropTypes from "prop-types"
import { forwardRef, useCallback, useEffect, useRef, useState } from "react"
import PlacesDropdownRenderer from "./PlacesDropdownRenderer"
const { useToken } = theme
const GooglePlacesNewInput = (
  {
    onInput,
    onChange,
    meetingLatLng,
    useDefaultValue = false,
    setManualAddress = () => {},
    setCenterLatLng,
    defaultValue = "",
    setMeetingLatLng,
    ...rest
  },
  ref
) => {
  const inputRef = useRef(null)
  const [predictions, , getPredictions, selectPlace] = usePredictions()
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [inputValue, setInputValue] = useState(defaultValue)
  const mergedRef = ref || inputRef
  const { token } = useToken()

  // Sync inputValue with external value prop
  useEffect(() => {
    setInputValue(meetingLatLng ?? undefined)
  }, [meetingLatLng])

  const handleInputChange = (event) => {
    const newValue = event.target.value
    setInputValue(newValue)
    getPredictions(newValue)
    setDropdownOpen(!!newValue)

    if (!newValue) {
      setCenterLatLng(null)
      setMeetingLatLng(null)
      setInputValue(undefined)
    }
  }

  const handleSelectPrediction = (placeId) => {
    selectPlace(placeId, (place) => {
      const formattedAddress = place.formatted_address
      setInputValue(formattedAddress)
      setDropdownOpen(false)

      if (typeof onChange === "function") {
        onChange({
          target: {
            value: formattedAddress,
            place,
            coordinates: {
              lat: place.geometry.location.lat(),
              lng: place.geometry.location.lng()
            }
          }
        })
      }
    })
  }

  const renderDropdown = useCallback(
    () => (
      <PlacesDropdownRenderer
        predictions={predictions}
        onSelectPrediction={handleSelectPrediction}
        onEnterManual={() => {
          setManualAddress(true)
          setDropdownOpen(false)
          setCenterLatLng(null)
          setMeetingLatLng(null)
        }}
      />
    ),
    [predictions, handleSelectPrediction, setManualAddress, setDropdownOpen, setCenterLatLng, setMeetingLatLng]
  )

  const handleClearInput = () => {
    setInputValue("")
    setDropdownOpen(false)
    setCenterLatLng(null)
    setMeetingLatLng(null)
  }

  return (
    <Dropdown open={dropdownOpen} onOpenChange={setDropdownOpen} dropdownRender={renderDropdown} trigger={["click"]}>
      <Input
        {...rest}
        ref={mergedRef}
        value={inputValue}
        placeholder="Type your address here"
        prefix={<EnvironmentOutlined style={{ color: token.colorPrimary, fontSize: 20 }} />}
        onChange={handleInputChange}
        suffix={
          inputValue && <CloseCircleOutlined style={{ color: "rgba(0, 0, 0, 0.45)", cursor: "pointer" }} onClick={handleClearInput} />
        }
        style={{ paddingLeft: 10, height: 40 }}
      />
    </Dropdown>
  )
}

GooglePlacesNewInput.propTypes = {
  onInput: PropTypes.func,
  onChange: PropTypes.func,
  useDefaultValue: PropTypes.bool,
  setManualAddress: PropTypes.func,
  defaultValue: PropTypes.string,
  meetingLatLng: PropTypes.string,
  value: PropTypes.string,
  setCenterLatLng: PropTypes.func,
  setMeetingLatLng: PropTypes.func
}

export default forwardRef(GooglePlacesNewInput)
